/** External consent forms. Default off; owner: Pavit Gogia. Review: 2026-11-30.
 * Cleanup: https://github.com/Borradh-Media/borradh-workspace/issues/1982
 */
export const EXTERNAL_CONSENT_FORMS_FLAG = 'rollout-external-consent-forms';
export const EXTERNAL_CONSENT_FORMS_FLAG_NAME = 'External consent forms';
//# sourceMappingURL=external-consent-forms.js.map